import React, { useState } from "react";

import { FiChevronsRight } from "react-icons/fi";
import "./sideMenu.css";

const SideMenu = props => {
	const [isSideMenuVisible, setSideMenuVisible] = useState(false);
	return (
		<div className="side-menu">
			<FiChevronsRight
				className={isSideMenuVisible ? "side-menu-icon-hidden" : "side-menu-icon-visible"}
				onClick={() => setSideMenuVisible(true)}
			/>
			<div className={isSideMenuVisible ? "side-menu-visible" : "side-menu-hidden"}>
				<div className="background-clicker" onClick={() => setSideMenuVisible(false)}></div>
				<div className="side-menu-container">
					<input
						type="button"
						value="RESIGN"
						className="side-menu-option"
						onClick={() => {
							setSideMenuVisible(false);
							props.handleResignation();
						}}
					/>
					<input
						type="button"
						value="OFFER DRAW"
						className="side-menu-option"
						onClick={() => {
							// console.log("DRAW");
							setSideMenuVisible(false);
							props.handleDraw();
						}}
					/>
					<input
						type="button"
						value="MAIN MENU"
						className="side-menu-option"
						onClick={() => (window.location = window.location.origin)}
					/>
				</div>
			</div>
		</div>
	);
};

export default SideMenu;
